import React, { Component } from "react";
import { Route, Redirect } from "react-router-dom";
import Dashboard from "../Components/Dashboard/Dashboard";
import VisitorPermit from "../Components/VisitorPermit/VisitorPermit";
import UserProfile from "../Components/UserProfile/UserProfile";
import Contact from "../Components/Contact/Contact";
import CurrentPermit from "../Components/CurrentPermit/CurrentPermit";
import Residents from "../Components/Residents/Residents";
import CurrentVisitorPermit from "../Components/CurrentVisitorPermit/CurrentVisitorPermit";
import ViewResidents from "../Components/ViewResidents/ViewResidents";
import AddResidents from "../Components/AddResidents/AddResidents";
import Enforcement from "../Components/Enforcement/Enforcement";
import EnforcementReportPhotoVerify from "../Components/EnforcementReportPhotoVerify/EnforcementReportPhotoVerify";
import EnforcementReportCitationPaidSummary from "../Components/EnforcementReportCitationPaidSummary/EnforcementReportCitationPaidSummary";
import EnforcementReportCitationIssued from "../Components/EnforcementReportCitationIssued/EnforcementReportCitationIssued";
import EnforcementReportCitationAnalysis from "../Components/EnforcementReportCitationAnalysis/EnforcementReportCitationAnalysis";
import AddQuickPermit from "../Components/AddQuickPermit/QuickPermit";
import TicketReport from "../Components/TicketReport/TicketReport";
import RevenueReport from "../Components/RevenueReport/RevenueReport";
import DispenserReport from "../Components/TicketDispenserReport/Ticket_dispenser_report";
import VendControlReport from "../Components/VendControlReport/VendControlReport";
import HealthReport from "../Components/HealthReport/HealthReport";
import ResidentPermit from "../Components/ResidentPermit/ResidentPermit";
import EditResident from "../Components/EditResident/EditResident";
import LRPReport from "../Components/LRPReport/LRPReport";
import CurrentOccupancy from "../Components/CurrentOccupancy/CurrentOccupancy";
import ResidentOccupancy from "../Components/ResidentOccupancy/ResidentOccupancy";
import Sidebar from "../Components/Sidebar/Sidebar";
import AdminNavbar from "../Components/Navbars/AdminNavbar";
import sidebarImage from "../../assets/img/sidebar-5.jpg";
import adminDashboardRoutes from "../../adminDashboardRoutes";
import "react-perfect-scrollbar/dist/css/styles.css";
import PlateCheck from "../PlateCheck/PlateCheck";
import SendEmail from "../Components/SendEmail/SendEmailForm";
import AddUnitPermit from "../Components/AddUnitPermit/AddUnitPermit";
import Ticket from "../Components/Ticket/Ticket";
import TicketList from "../Components/Ticket/TicketList";
import Dispute from "../Components/Ticket/Dispute";
import Footer from "../Components/Footer";
import Privacy from "../Components/PrivacyPolicy/Privacy";
import PrivacyFrench from "../Components/PrivacyPolicy/PrivacyFrench";
import AuditReport from "../Components/AuditReport/AuditReport";
import { connect } from "react-redux";
import { SuperAdminAction } from "../Actions";
import ViewOccupancy from "../Components/LotOccupancy/ViewOccupancy";
import MerchantValidation from "../Components/Validation/Validation";
import RateTracking from "../Components/RateTracking/RatePayment";
import Transactions from "../Components/TransactionReport/TransactionReport";
import Refund from "../Components/Refund/Refund";
import LiveFeed from "../Components/LiveFeed/LiveFeed";
import SmartGate from "../Components/SmartGate/SmartGate";
import LotSharing from "../Components/LotSharing/LotSharing";
import ActivityLog from "../Components/ActivityLog/ActivityLog";

import "../../../src/assets/css/demo.css";
import PublicRouteInPrivate, {
  PublicRouteInPrivateList,
} from "./PublicRouteInPrivate";
import SelfRegisterMainHeader from "../Components/SelfRegister/SelfRegisterMainHeader";
const AllValidPages = [
  {
    name: "DASHBOARD",
    url: "/dashboard",
  },
  {
    name: "LPR REPORT",
    url: "/lpr-report",
  },
  {
    name: "PARKING LOG",
    url: "/unit-occupancy",
  },
  {
    name: "UNITS AND PERMITS",
    url: "/units",
  },
  {
    name: "OCCUPANCY",
    url: "/view-occupancy",
  },
  {
    name: "UNITS AND PERMITS",
    url: "/add-unit",
  },
  {
    name: "UNITS AND PERMITS",
    url: "/view-units",
  },
  {
    name: "UNITS AND PERMITS",
    url: "/unit-permit",
  },
  {
    name: "UNITS AND PERMITS",
    url: "/edit-unit",
  },
  {
    name: "VIEW ALL PERMITS",
    url: "/current-permits",
  },
  {
    name: "PHOTO VERIFY",
    url: "/photo-verify",
  },
  {
    name: "PLATE AUDIT",
    url: "/current-occupancy",
  },
  {
    name: "PHOTO VERIFY",
    url: "/plate-check",
  },
  {
    name: "PHOTO VERIFY",
    url: "/add-unit-permit",
  },
  {
    name: "PHOTO VERIFY",
    url: "/send-email",
  },
  {
    name: "PHOTO VERIFY",
    url: "/citation",
  },
  {
    name: "PHOTO VERIFY",
    url: "/audit-report",
  },
  {
    name: "LIVE FEED",
    url: "/live-feed",
  },
  {
    name: "SMART GATE",
    url: "/smart-gate",
  },
  {
    name: "REPORT",
    url: "/report",
  },
  {
    name: "CITATION REPORT",
    url: "/report-citation",
  },
  {
    name: "REVENUE REPORT",
    url: "/report-revenue",
  },
  {
    name: "TICKET DISPENSER REPORT",
    url: "/report-dispenser",
  },
  {
    name: "VEND CONTROL REPORT",
    url: "/report-vend-control",
  },
  {
    name: "VALIDATION REPORT",
    url: "/report-validation",
  },
  {
    name: "RATE TRACKING REPORT",
    url: "/report-rate-tracking",
  },
  {
    name: "TRANSACTIONS REPORT",
    url: "/report-transactions",
  },
  {
    name: "HEALTH REPORT",
    url: "/report-health",
  },
  {
    name: "PHOTO VERIFY REPORT",
    url: "/report-enforcement-photo-verify",
  },
  {
    name: "CITATION ISSUED REPORT",
    url: "/report-enforcement-citation-issued",
  },
  {
    name: "CITATION PAID REPORT",
    url: "/report-enforcement-citation-paid-summary",
  },
  {
    name: "CITATION ANALYSIS REPORT",
    url: "/report-enforcement-citation-analysis",
  },
  {
    name: "ADD VISITOR",
    url: "/visitor-permit",
  },
  {
    name: "CITATIONS",
    url: "/citation-list",
  },
  {
    name: "CITATIONS",
    url: "/dispute",
  },
  {
    name: "CURRENT VISITORS",
    url: "/current-visitor-permit",
  },
  {
    name: "MY ACCOUNT",
    url: "/user-profile",
  },
  {
    name: "CONTACT SUPPORT",
    url: "/contact",
  },
  // {
  //   name: "USERS",
  //   url: "/dt",
  // },
  {
    name: "USERS",
    url: "/privacy-policy",
  },
  {
    name: "USERS",
    url: "/privacy-policy-french",
  },
  {
    name: "LOT SHARING",
    url: "/lot-sharing",
  },
  {
    name: "ACTIVITY LOGS REPORT",
    url: "/activity-log-report",
  },
  {
    name: "QUICK PERMITS",
    url: "/add-quick-permit",
  },
  {
    name: "SELF REGISTER",
    url: "/self-register",
  },
  {
    name: "REFUND REPORT",
    url: "/refund",
  },
];

class AdminRoutes extends Component {
  constructor(props) {
    super(props);
    this.state = {
      UserProfileDetails: null,
      user_type: "",
      image: sidebarImage,
      color: "black",
      isSidebarHidden: false,
      isShowSidebar: true,
      footerSize: false,
      AllValidPages: AllValidPages,
      routePermission: false,
      mainRoutes: [],
      urlPath: "",
    };
    this.mainPanel = React.createRef(null);
  }

  componentDidMount = async () => {
    this.setState({
      isSidebarHidden: this.props.isSidebarHidden,
      isShowSidebar: this.props.isShowSidebar,
    });
    const selectedRoutes = [];
    await this.props.getPermission();
    if (this.props.api_response) {
      if (this.props.allPermissions) {
        let modifiedPermissionList = [];
        this.props.allPermissions.forEach((element) => {
          modifiedPermissionList.push(
            element.toLowerCase().replace(/[^a-z]/g, "")
          );
        });
        modifiedPermissionList.push(
          "DASHBOARD",
          "CONTACT SUPPORT",
          "MY ACCOUNT",
          // "ACTIVITY LOG",
          // "REPORT",
          // "DISPENSER REPORT",
          "USERS",
          "LOT SHARING"
        );
        const isReportExist = this.props?.allPermissions.find(
          (obj) => obj.toLowerCase().replace(/[^a-z]/g, "") === "report"
        );
        if (!isReportExist) {
          modifiedPermissionList = modifiedPermissionList.filter(
            (item) => !item.includes("report")
          );
        }
        for (const item of this.state.AllValidPages) {
          const isExits = modifiedPermissionList.find(
            (name) =>
              name.toLowerCase().replace(/[^a-z]/g, "") ===
              item.name.toLowerCase().replace(/[^a-z]/g, "")
          );
          if (isExits) {
            selectedRoutes.push(item.url);
          }
        }
      }
      this.setState({
        mainRoutes: selectedRoutes,
      });
    }
  };

  handleToogle = () => {
    if (this.state.isSidebarHidden === false) {
      this.setState({ footerSize: true });
    } else {
      this.setState({ footerSize: false });
    }
    this.setState({ isSidebarHidden: !this.state.isSidebarHidden });
  };

  handleSidebarChange = (value) => {
    this.setState({ isSidebarHidden: value });
  };

  isPublicRoute = () => {
    return PublicRouteInPrivateList.find(
      (x) => this.props.location.pathname.indexOf(x) !== -1
    );
  };

  ShowSideBar = () => {
    if (this.props.isSemiLogin) {
      if (this.props.menu) {
        return (
          <Sidebar
            color={this.state.color}
            image={this.state.image}
            isSidebarHidden={this.state.isSidebarHidden}
            routes={adminDashboardRoutes}
            handleSidebar={this.handleSidebarChange}
            timezone={this.props.timezone}
            isSemiLogin={this.props.isSemiLogin}
          />
        );
      }
    } else {
      return (
        <Sidebar
          color={this.state.color}
          image={this.state.image}
          isSidebarHidden={this.state.isSidebarHidden}
          routes={adminDashboardRoutes}
          handleSidebar={this.handleSidebarChange}
          timezone={this.props.timezone}
          isSemiLogin={this.props.isSemiLogin}
        />
      );
    }
  };

  getSidebarClass = () => {
    const { isSidebarHidden } = this.state;
    let classname = "main-panel";
    if (isSidebarHidden) {
      classname = "main-panel expanded";
    }
    return classname;
  };

  render() {
    const { isShowSidebar, footerSize, mainRoutes } = this.state;
    const isValid =
      this.props.location.pathname.indexOf("visitor-permit") !== -1;
    return (
      <>
        <div
          className={
            "wrapper " + (!this.props.menu ? "without-sidebar-full-page" : "")
          }
        >
          {this.isPublicRoute() ? (
            <>
              <SelfRegisterMainHeader />
              <PublicRouteInPrivate {...this.props} />
              <div className="full-page">
                <Footer />
              </div>
            </>
          ) : (
            <>
              {this.ShowSideBar()}
              <div className={this.getSidebarClass()} ref={this.mainPanel}>
                {!this.props.isSemiLogin && (
                  <AdminNavbar
                    handleSiderHide={this.handleToogle}
                    domainHeader={this.props.domainHeader}
                    isShowSidebar={isShowSidebar}
                    admin={true}
                    userType={this.props.user_type}
                    adminLogin={this.props.admin_login}
                    permission_id={this.props.permission_id}
                    timezone={this.props.timezone}
                  />
                )}
                <div className="content pt-3 pb-3 h-100">
                  {mainRoutes.length > 0 && (
                    <>
                      {(mainRoutes.indexOf(this.props.location.pathname) !==
                        -1 ||
                        isValid) && (
                        <>
                          <Route
                            exact
                            path="/dashboard"
                            render={() => <Dashboard {...this.props} />}
                          />
                          <Route
                            exact
                            path="/units"
                            render={() => <Residents {...this.props} />}
                          />
                          <Route
                            exact
                            path="/view-units"
                            render={() => <ViewResidents {...this.props} />}
                          />
                          <Route
                            exact
                            path="/view-occupancy"
                            render={() => <ViewOccupancy {...this.props} />}
                          />
                          <Route
                            exact
                            path="/visitor-permit"
                            render={() => <VisitorPermit {...this.props} />}
                          />
                          <Route
                            exact
                            path="/visitor-permit/:menu/:domain/:user/:epoch/:key"
                            render={() => <VisitorPermit {...this.props} />}
                          />
                          <Route
                            exact
                            path="/current-visitor-permit"
                            render={() => (
                              <CurrentVisitorPermit {...this.props} />
                            )}
                          />
                          <Route
                            exact
                            path="/current-permits"
                            render={() => <CurrentPermit {...this.props} />}
                          />
                          <Route
                            exact
                            path="/report-citation"
                            render={() => <TicketReport {...this.props} />}
                          />
                          <Route
                            exact
                            path="/report-revenue"
                            render={() => <RevenueReport {...this.props} />}
                          />
                          <Route
                            exact
                            path="/report-health"
                            render={() => <HealthReport {...this.props} />}
                          />
                          <Route
                            exact
                            path="/report-enforcement-photo-verify"
                            render={() => (
                              <EnforcementReportPhotoVerify {...this.props} />
                            )}
                          />
                          <Route
                            exact
                            path="/report-enforcement-citation-paid-summary"
                            render={() => (
                              <EnforcementReportCitationPaidSummary
                                {...this.props}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/report-enforcement-citation-issued"
                            render={() => (
                              <EnforcementReportCitationIssued
                                {...this.props}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/report-enforcement-citation-analysis"
                            render={() => (
                              <EnforcementReportCitationAnalysis
                                {...this.props}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/photo-verify"
                            render={() => <Enforcement {...this.props} />}
                          />
                          <Route
                            exact
                            path="/plate-check"
                            render={() => <PlateCheck {...this.props} />}
                          />
                          <Route
                            exact
                            path="/send-email"
                            render={() => <SendEmail {...this.props} />}
                          />
                          <Route
                            exact
                            path="/user-profile"
                            render={() => <UserProfile {...this.props} />}
                          />
                          <Route
                            exact
                            path="/contact"
                            render={() => <Contact {...this.props} />}
                          />
                          <Route
                            exact
                            path="/add-unit"
                            render={() => <AddResidents {...this.props} />}
                          />
                          <Route
                            exact
                            path="/unit-permit"
                            render={() => <ResidentPermit {...this.props} />}
                          />
                          <Route
                            exact
                            path="/edit-unit"
                            render={() => <EditResident {...this.props} />}
                          />
                          <Route
                            exact
                            path="/lpr-report"
                            render={() => <LRPReport {...this.props} />}
                          />
                          <Route
                            exact
                            path="/current-occupancy"
                            render={() => <CurrentOccupancy {...this.props} />}
                          />
                          <Route
                            exact
                            path="/add-unit-permit"
                            render={() => <AddUnitPermit {...this.props} />}
                          />
                          <Route
                            exact
                            path="/unit-occupancy"
                            render={() => <ResidentOccupancy {...this.props} />}
                          />
                          <Route
                            exact
                            path="/citation"
                            render={() => <Ticket {...this.props} />}
                          />
                          <Route
                            exact
                            path="/citation-list"
                            render={() => <TicketList {...this.props} />}
                          />
                          <Route
                            path="/dispute"
                            render={() => (
                              <Dispute {...this.props} history={history} />
                            )}
                          />
                          <Route
                            exact
                            path="/privacy-policy"
                            render={() => (
                              <Privacy {...this.props} history={history} />
                            )}
                          />
                          <Route
                            exact
                            path="/privacy-policy-french"
                            render={() => (
                              <PrivacyFrench
                                {...this.props}
                                history={history}
                              />
                            )}
                          />
                          <Route
                            exact
                            path="/audit-report"
                            render={() => (
                              <AuditReport {...this.props} history={history} />
                            )}
                          />
                          <Route
                            exact
                            path="/visitor-permit/:menu"
                            render={() => <VisitorPermit {...this.props} />}
                          />
                          <Route
                            exact
                            path="/report-dispenser"
                            render={() => <DispenserReport {...this.props} />}
                          />
                          <Route
                            exact
                            path="/report-vend-control"
                            render={() => <VendControlReport {...this.props} />}
                          />
                          <Route
                            exact
                            path="/report-validation"
                            render={() => (
                              <MerchantValidation {...this.props} />
                            )}
                          />
                          <Route
                            exact
                            path="/report-rate-tracking"
                            render={() => <RateTracking {...this.props} />}
                          />
                          <Route
                            exact
                            path="/refund"
                            render={() => <Refund {...this.props} />}
                          />
                          <Route
                            exact
                            path="/activity-log-report"
                            render={() => <ActivityLog {...this.props} />}
                          />
                          <Route
                            exact
                            path="/report-transactions"
                            render={() => <Transactions {...this.props} />}
                          />
                          <Route
                            exact
                            path="/live-feed"
                            render={() => <LiveFeed {...this.props} />}
                          />
                          <Route
                            exact
                            path="/smart-gate"
                            render={() => <SmartGate {...this.props} />}
                          />
                          <Route
                            exact
                            path="/lot-sharing"
                            render={() => <LotSharing {...this.props} />}
                          />
                          <Route
                            exact
                            path="/add-quick-permit"
                            render={() => <AddQuickPermit {...this.props} />}
                          />
                        </>
                      )}
                      {!(
                        mainRoutes.indexOf(this.props.location.pathname) !==
                          -1 || isValid
                      ) && (
                        <Route
                          render={() => (
                            <Redirect to={{ pathname: "/dashboard" }} />
                          )}
                        />
                      )}
                    </>
                  )}
                </div>
                {footerSize && (
                  <div className="footer-full-page">
                    <Footer />
                  </div>
                )}
                {!footerSize && <Footer />}
              </div>
            </>
          )}
        </div>
      </>
    );
  }
}

const mapStateToProps = ({
  SuperAdminDetails,
  UserProfileDetails,
  APIResponseDetails,
}) => {
  const { userModulePermissions, permissions: allPermissions } =
    SuperAdminDetails;
  const { user_type, property_id, permission_id, timezone } =
    UserProfileDetails;
  const { api_response, api_error_message, api_success_message } =
    APIResponseDetails;
  return {
    timezone,
    userModulePermissions,
    allPermissions,
    property_id,
    api_response,
    api_error_message,
    api_success_message,
    user_type,
    permission_id,
  };
};
const mapStateToDispatch = {
  getPermission: SuperAdminAction.getPermission,
};

export default connect(mapStateToProps, mapStateToDispatch)(AdminRoutes);
